import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import vi from "./vi.json";

i18n
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, vi: { translation: vi } },
    lng: "en",
    fallbackLng: "en",
    supportedLngs: ["en", "vi"],
    interpolation: { escapeValue: false },
  });

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language?.split("-")[0] || "en";
  i18n.on("languageChanged", (lng) => {
    document.documentElement.lang = (lng || "en").split("-")[0];
  });
}

export default i18n;
